import { Button, Flex, Form, Input, Modal } from 'antd'
import { FormInstance, ModalProps } from 'antd/lib'

import { ClassifierCategory, ClassifierType } from 'src/api/requests'
import { requiredRules } from 'src/app-constants'
import { ClassifierInfiniteSelect } from 'src/components'
import { useClassifierId } from 'src/hooks'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = {
  onCancel: () => void
  onConfirm: () => void
  form: FormInstance
} & ModalProps

export const CancelInvestigationModal = ({
  onCancel,
  onConfirm,
  form,
  ...props
}: Props) => {
  const { t } = useLocales()
  const { styles } = useStyles()

  const classifierId = useClassifierId(
    ClassifierType.CANCELLATION_REASON,
    ClassifierCategory.INVESTIGATIONS
  )

  const onSubmit = async () => {
    await form.validateFields()
    onConfirm()
  }

  return (
    <Modal
      open
      maskClosable={false}
      centered
      width={520}
      title={t('investigations.cancel_investigation')}
      footer={null}
      onCancel={onCancel}
      {...props}
    >
      <Form layout="vertical" form={form}>
        <Flex vertical gap={24}>
          <Form.Item
            name="reasonId"
            rules={requiredRules}
            label={t('investigations.cancellation_reason')}
          >
            <ClassifierInfiniteSelect
              id={classifierId}
              placeholder={t('investigations.cancellation_reason')}
            />
          </Form.Item>

          <Form.Item
            name="notes"
            label={t('investigations.cancellation_comments')}
            rules={requiredRules}
          >
            <Input.TextArea
              className={styles.textarea}
              placeholder={t('investigations.cancellation_comments')}
            />
          </Form.Item>

          <Flex justify="center" gap={16}>
            <Button onClick={onCancel}>{t('common.cancel')}</Button>

            <Button color="danger" variant="solid" onClick={onSubmit}>
              {t('roles.confirm')}
            </Button>
          </Flex>
        </Flex>
      </Form>
    </Modal>
  )
}
